import angular from 'angular';

angular.module('AaApp.Opp').constant('reportSubscriptionPeriods', {
    daily: 1,
    weekly: 2,
    monthly: 3
})
